//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";

export default {
    components: {
        AQTooltip
    },
    props: {
        iconRight: { type: String, default: "chevron_right" },
        iconLeft: { type: String, default: "" },
        title: { type: String, default: "" },
        subTitle: { type: String, default: "" }
    },
    data() {
        return {};
    },
    methods: {
        emitClick(evt) {
            this.$emit("click", evt);
        }
    }
};
